<template id="abcd">
  <div class="parentswiper group_sw">
    <div class="wrapperswiper">
      <swiper :options="swiperOptions" ref="mySwiper" class="wrapperswiper" v-if="list.length>0">
        <!-- slides -->
        <swiper-slide v-for="(item1,index) in swiperSlideList" :key="index">
          <ul>
            <li v-for="item in item1" :key="item.topicId">
              <router-link target="_blank" :to="'/subjectdetail/' + item.topicId">
                <img :src="item.img | imageUrl('',432,360)" />
                <p>{{item.name}}</p>
              </router-link>
              <!--<span>{{item.topicTitle}}</span>-->
            </li>
          </ul>
        </swiper-slide>
      </swiper>
    </div>
    <div
      class="swiperbutton-prev buttonArrow"
      id="sqsvg"
      @mouseover="changeArrowColor1($event)"
      @mouseout="resetColor1($event)"
    >
      <svg width="11" height="21" viewBox="0 0 18 32" fill="#657987" class="iris_ic is--32">
        <path
          d="M12.88 16L.44 3.56a1.498 1.498 0 0 1 0-2.12l1-1a1.496 1.496 0 0 1 2.12 0l13.854 14.145c.78.782.78 2.048 0 2.83L3.56 31.56a1.496 1.496 0 0 1-2.12 0l-1-1a1.498 1.498 0 0 1 0-2.12L12.88 16z"
          fill-rule="evenodd"
        />
      </svg>
    </div>

    <div
      class="swiperbutton-next buttonArrow"
      id="sqsvg1"
      @mouseover="changeArrowColor"
      @mouseout="resetColor"
    >
      <svg width="11" height="21" viewBox="0 0 18 32" fill="#657987" class="iris_ic is--32">
        <path
          d="M12.88 16L.44 3.56a1.498 1.498 0 0 1 0-2.12l1-1a1.496 1.496 0 0 1 2.12 0l13.854 14.145c.78.782.78 2.048 0 2.83L3.56 31.56a1.496 1.496 0 0 1-2.12 0l-1-1a1.498 1.498 0 0 1 0-2.12L12.88 16z"
          fill-rule="evenodd"
        />
      </svg>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "",
  components: {
    swiper,
    swiperSlide
  },
  props: {
    page_size: {
      type: Number,
      default: 9
    },
    filterParam: {
      type: Object
    },
    state: {
      type: Boolean
    },
    list: {
      type: Array
    }
  },
  data() {
    return {
      videoList: [],
      svgShowBox1: false,
      svgShowBox2: true,
      pagerParam: {
        pageSize: this.page_size,
        pageCount: 1,
        currentPage: 1,
        total: 1
      },
      swiperSlideList: [],
      isPreState: false,
      isNextState: false,
      swiperOptions: {
        navigation: {
          nextEl: "#sqsvg1",
          prevEl: "#sqsvg"
        },
        on: {
          /*slideChange() {
          //debugger
            setTimeout(() => {
              elm();
            }, 200);

            function elm() {
              const doc = document.getElementsByClassName('group_sw');
              if (doc != null){
                const swiperList = doc[0].getElementsByClassName("swiper-slide");
                for (let i = 0; i < swiperList.length; i++) {
                  const swiperEl = swiperList[i];
                //debugger
                  if (swiperEl.className.indexOf("swiper-slide-active") != -1) {
                    if (i == swiperList.length -1) {
                      $this_.isNextState = false;
                      $this_.isPreState = true;
                    }else {
                      $this_.isNextState = true;
                      if (i != 0 && i< swiperList.length) {
                        $this_.isPreState = true;
                      }else if(i== 0){
                        $this_.isPreState = false;
                      }
                    }
                  }
                }
              }
            }
          }*/
        }
      }
    };
  },
  created() {
    this.getGroupList();
    //Vue.prototype.$this_ = this;
  },
  watch: {
    list: {
      handler(val, oldVal) {
        this.getGroupList();
      },
      deep: true
    }
  },
  methods: {
    GoToSubjectDetail(id) {
      this.$router.push("/subjectdetail/" + id);
    },
    changeArrowColor() {
      let svgNode = document.getElementById("sqsvg1").firstChild;
      svgNode.setAttribute("fill", "#1a2e3b");
    },
    resetColor() {
      let svgNode = document.getElementById("sqsvg1").firstChild;
      svgNode.setAttribute("fill", "#657987");
    },
    changeArrowColor1(e) {
      var doc = e.target;
      let svgNode = doc.firstChild;
      /*if (this.isPreState) {*/
      svgNode.setAttribute("fill", "#1a2e3b");
      /*}*/
    },
    resetColor1(e) {
      var doc = e.target;
      let svgNode = doc.firstChild;
      if (this.isNextState) {
        svgNode.setAttribute("fill", "#657987");
      }
    },
    getGroupList() {
      if (this.list != null) {
        this.swiperSlide = [];
        var pagecount = this.$jsonUtils.getPageCount(this.list.length, 9);
        let item = null,
          copyItem = {};
        for (var i = 0, n = pagecount; i < n; i++) {
          copyItem = this.$jsonUtils.pagination(i + 1, 9, this.list);
          this.swiperSlideList.push(copyItem);
        }

        if (this.swiperSlideList.length <= 9) {
          this.isPreState = false;
          this.isNextState = false;
        } else {
          this.isNextState = true;
        }
      }
    }
  }
};
</script>

<style scoped>
.wrapperswiper {
  position: relative;
  width: 650px;
  margin: 30px auto;
}
.wrapperswiper .swiperbutton-prev {
  left: 20px;
}
.wrapperswiper .swiperbutton-next {
  right: 20px;
}
.wrapperswiper ul {
  width: 1160px;
  height: inherit;
  overflow: hidden;
  margin: 0 auto;
}
.wrapperswiper ul li {
  float: left;
  height: inherit;
  width: 50px;
  margin-right: 25px;
}
.wrapperswiper ul li:last-child {
  margin-right: 0;
}
.wrapperswiper ul li a {
  display: block;
  width: 100%;
  height: inherit;
}
.wrapperswiper ul li a img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.wrapperswiper ul li a p {
  font-size: 12px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 5px;
  width: 50px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.svgshowbox1 {
  position: absolute;
  top: 50%;
  width: 27px;
  height: 44px;
  margin-top: -22px;
  z-index: 11;
  right: -50px;
}
.svgshowbox2 {
  position: absolute;
  top: 50%;
  width: 27px;
  height: 44px;
  margin-top: -22px;
  z-index: 11;
  left: -40px;
}
.swiperbutton-prev {
  left: 20px;
}
.swiperbutton-next {
  right: 20px;
}
.swiperbutton-next, .swiperbutton-prev{
    width: 11px;
    height: 21px;
    top: 90px;
    margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/list/swiper_member.vue